<script setup>
import { computed } from 'vue'
import { Typography } from '@aryeo/runway'

const props = defineProps({
  text: {
    type: [String, Number],
    required: true,
  },
  textVariant: {
    type: String,
    default: 'label',
  },
  color: {
    type: String,
    default: 'success',
    validator: (value) =>
      [
        'primary',
        'info',
        'warning',
        'success',
        'default',
        'critical',
        'danger',
        'aqua',
        'blue',
        'orange',
        'purple',
        'teal',
        'red',
      ].includes(value),
  },
  overrideBackgroundColor: {
    type: String,
  },
  overrideTextColor: {
    type: String,
  },
  circular: {
    type: Boolean,
    default: false,
  },
})

const shapeClasses = computed(() => {
  return props.circular
    ? 'rounded-full w-6 h-6 leading-6 text-center p-0'
    : 'rounded-full py-1 px-2'
})

const bgColorClasses = computed(() => {
  if (props.overrideBackgroundColor) {
    return props.overrideBackgroundColor
  }

  return {
    primary: 'bg-primary',
    warning: 'bg-tag-warning',
    success: 'bg-tag-success',
    info: 'bg-tag-info',
    critical: 'bg-tag-critical',
    danger: 'bg-tag-danger',
    aqua: 'bg-tag-aqua',
    blue: 'bg-tag-blue',
    orange: 'bg-tag-orange',
    purple: 'bg-tag-purple',
    teal: 'bg-tag-teal',
    red: 'bg-tag-red',
  }[props.color]
})
</script>

<template>
  <div class="inline-flex items-center" :class="[bgColorClasses, shapeClasses]">
    <div class="mr-2" v-if="$slots.left">
      <slot name="left" />
    </div>

    <Typography
      :variant="textVariant"
      :color="color === 'primary' ? 'white' : 'body'"
      :class="'whitespace-nowrap ' + overrideTextColor"
    >
      {{ text }}
    </Typography>

    <div class="ml-2" v-if="$slots.right">
      <slot name="right" />
    </div>
  </div>
</template>
